<ng-container *ngIf="!isOptionLoading;else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'包月資訊'"></app-nav-header>  
  <ng-container *ngIf="!!editModel && editModel.length>0;else noData">
  <p-accordion [multiple]="true" [activeIndex]="[0]">
    <p-accordionTab *ngFor="let sub of editModel" header="剩餘{{ sub.SubProM.RestOfTimes }}次   {{ sub.SubProM.DateFrom }}至{{ sub.SubProM.DateTo }}">
        <div class="card">
          <p-dataView #dv [value]="sub.SubProDs">
              <ng-template pTemplate="list" let-products>
                  <div class="grid grid-nogutter">
                      <div *ngFor="let item of products;  let i = index;let first = first" class="col-12">
                          <div class="flex flex-row align-items-center p-4 gap-4 item-row" [ngClass]="{ 'border-top-1 surface-border': !first }">
                              <div class="text-nowrap">
                                  第{{ i+1 }}次
                              </div>
                              <div class="text-nowrap">
                                  {{ item.UseDate }}
                              </div>
                              <div class="text-nowrap">
                                  <img *ngIf="!!item.SignPath;" src="{{ baseUrl }}/{{ item.SignPath }}" width="100px">
                                  <button *ngIf="!!item.SignPath == false;" pButton type="button" label="簽名" class="p-button-info" (click)="Sign(item)"></button>
                              </div>
                          </div>
                      </div>
                  </div>
              </ng-template>
          </p-dataView>
      </div>
    </p-accordionTab>
  </p-accordion>   
    <p-sidebar [(visible)]="showDialog" [fullScreen]="true">
       <ng-template pTemplate="header">
            <span class="font-semibold text-xl">
               簽名板
            </span>
       </ng-template>
       <div class="signature-container p-3">
            <div class="sign-box">
               <ngx-signature-pad #sig [options]="options" class="sign-canvas"
                    (beginSign)="onBegin()"
                    (endSign)="onEnd()">
                </ngx-signature-pad>
            </div>
            <button pButton label="清除" class="p-button-secondary w-full" (click)="clear()"></button>
            <button pButton label="儲存" class="p-button-success w-full" (click)="save()"></button>
        </div>
    </p-sidebar>   
  </ng-container>
  <ng-template #noData>
    <div class="empty-container">
         <p>目前無包月紀錄</p>
    </div>
  </ng-template>            
</ng-container>
<ng-template #Loading>
<p-progressSpinner ariaLabel="loading" />
</ng-template>
